'use strict'

/**
 *
 * @name: nnBlackAndWhiteModal
 *
 */
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import moment from 'moment-timezone'

import ButtonTemplate from './nn-black-and-white-modal.directive.html'
import './nn-black-and-white-modal.directive.scss'

function NnBlackAndWhiteModalDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: ButtonTemplate,
    controller: nnBlackAndWhiteModalDirectiveController
  }
}

function nnBlackAndWhiteModalDirectiveController ($scope, $localStorage, $rootScope, $timeout, $element) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */


  /*
   *
   * @PUBLIC
   *
   */

  $scope.setSiteBlack = val => {
    $rootScope.isSiteThemeBlack = val
    $localStorage.isSiteThemeBlack = val
    _animate(val)
  }

  $scope.hover = val => {
    if (!$rootScope.isMobileDevice) {
      $scope.hoveredHalf = val
    }
  }

  $scope.close = () => {
    $rootScope.showBlackWhiteModal = false
    enableBodyScroll($element[0]);

    // for debug:
    // $timeout(() => {
    //   $rootScope.showBlackWhiteModal = true
    //   $scope.stretchWhite = false
    //   $scope.stretchBlack = false
    //   $scope.animateLogo = false
    // }, 2000)
  }

  $scope.isRightTime = () => {
    const time = moment.tz('Asia/Shanghai').format('DMYYYY')
    return time >= 11112018 && time <= 30112018
  }

  $scope.showModal = () => {
    return $rootScope.showBlackWhiteModal && $rootScope.lang === 'zh-cn' && $scope.isRightTime()
  }


  /*
   *
   * @PRIVATE
   *
   */


  function _animate (val) {
    if (!$rootScope.isMobileDevice) {
      if (val) {
        $scope.stretchBlack = true
      } else {
        $scope.stretchWhite = true
      }
    }

    $timeout(() => {
      $scope.animateLogo = true
    }, 700)

    .then(() => {
      $timeout(() => {
        $scope.close()
      }, 200)
    })
  }

  /*
   *
   * @INIT
   *
   */

  if ($scope.showModal()) {

    disableBodyScroll($element[0]);
  }

}

export default NnBlackAndWhiteModalDirective



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-black-and-white-modal/nn-black-and-white-modal.directive.js